// API client for the uplevate-ai SPA. Same origin, cookie session — nothing stored in
// localStorage except the theme. Pages import these and call them from Python.

const BASE = '/api';

async function req(method, path, body) {
  const init = { method, headers: {}, credentials: 'same-origin' };
  if (body !== undefined && body !== null) {
    init.headers['Content-Type'] = 'application/json';
    init.body = JSON.stringify(body);
  }
  const resp = await fetch(BASE + path, init);
  const ct = resp.headers.get('content-type') || '';
  const data = ct.includes('application/json') ? await resp.json() : await resp.text();
  if (resp.status === 401) { window.location.href = '/api/auth/login?next=' + encodeURIComponent(location.pathname); throw new Error('sign in'); }
  if (!resp.ok) {
    const err = new Error((data && data.detail) ? data.detail : ('HTTP ' + resp.status));
    err.status = resp.status; err.data = data; throw err;
  }
  return data;
}

// ---- identity / workspace ---------------------------------------------------
export const getMe = () => req('GET', '/me');
export const logout = async () => { const r = await req('POST', '/auth/logout'); window.location.href = r.redirect || '/'; };
export const getWorkspace = () => req('GET', '/workspace');
export const wakeWorkspace = () => req('POST', '/workspace/wake');
export const sleepWorkspace = () => req('POST', '/workspace/sleep');
export const setKeepAwake = (on) => req('POST', '/workspace/keep_awake', { on: !!on });
export const getUsage = () => req('GET', '/workspace/usage');

// ---- projects ---------------------------------------------------------------
export const listProjects = () => req('GET', '/projects');
export const createProject = (title, mode) => req('POST', '/projects', { title, mode: mode || 'auto' });
export const getProject = (id) => req('GET', '/projects/' + id);
export const updateProject = (id, fields) => req('PATCH', '/projects/' + id, fields);
export const archiveProject = (id) => req('POST', '/projects/' + id + '/archive');
export const listFiles = (id) => req('GET', '/projects/' + id + '/files');
export const readFile = (id, path) => req('GET', '/projects/' + id + '/file?path=' + encodeURIComponent(path));

// ---- chat -------------------------------------------------------------------
export const sendMessage = (id, text, attachments) => req('POST', '/projects/' + id + '/messages', { text, attachments: attachments || [] });
export const answerCallback = (id, payload) => req('POST', '/projects/' + id + '/answer', payload);
export const cancelTurn = (id) => req('POST', '/projects/' + id + '/cancel');

// ---- keys -------------------------------------------------------------------
export const listKeys = () => req('GET', '/keys');
export const createKey = (name, scopes) => req('POST', '/keys', { name, scopes });
export const revokeKey = (id) => req('DELETE', '/keys/' + id);

// ---- live stream ------------------------------------------------------------
// Opens the project's SSE stream (data-only frames carrying {type, seq, ...}) and calls
// onEvent for each. Returns a closer. Reconnects itself from the last seq on drop.
export function streamProject(id, after, onEvent, onStatus) {
  let es = null, last = after || 0, closed = false;
  function open() {
    es = new EventSource(BASE + '/projects/' + id + '/stream?after=' + last, { withCredentials: true });
    es.onmessage = (e) => {
      let ev; try { ev = JSON.parse(e.data); } catch (err) { return; }
      if (ev.seq) last = ev.seq;
      onEvent(ev);
    };
    es.onopen = () => onStatus && onStatus('open');
    es.onerror = () => { onStatus && onStatus('reconnecting'); es.close(); if (!closed) setTimeout(open, 1500); };
  }
  open();
  return () => { closed = true; if (es) es.close(); };
}

export function currentTheme() { return document.documentElement.getAttribute('data-theme') || 'dark'; }
export function toggleTheme() {
  const t = currentTheme() === 'dark' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', t);
  try { localStorage.setItem('theme', t); } catch (e) {}
  return t;
}
